import { ProfileTypes, ProfileV2 } from '../../../types';

export default function ({ profileType }: ProfileV2) {
  return profileType === ProfileTypes.Combined
    ? ProfileTypes.Shared
    : profileType;
}
